import axios from "axios";
import * as urlHeader from "./url-header";

const API_URL = "http://localhost:8080/api/auth/";

const register = (username, email, password) => {
  return axios.post(urlHeader.authHeader + "signup", {
    username,
    email,
    password,
  });
};

const login = (username, password) => {
  console.log("START LOGIN")
  console.log("urlHeader.authHeader + \"signin\" = " + urlHeader.authHeader + "signin")
  return axios
    .post(urlHeader.authHeader + "signin", {
      username,
      password,
    })
    .then((response) => {
      console.log("RESPONSE START")
      console.log(response.headers)
      console.log(response.data)
      console.log(response.status)
      console.log(response.statusText)
      console.log("RESPONSE END")
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      console.log("RESPONSE START 2")
      console.log(response.headers)
      console.log(response.data)
      console.log(response.status)
      console.log(response.statusText)
      console.log("RESPONSE END 2")

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

export default {
  register,
  login,
  logout,
  getCurrentUser,
};
